module.exports = __webpack_public_path__ + "static/img/galogo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/galogo.png
// module id = QJuH
// module chunks = 26